export function openTab() {
    if (!document.getElementById('showMoreButton'))
        return;

    let button = document.getElementById('showMoreButton');
    let moreInfoTab = document.getElementById('product-more-info');
    let moreInfoText = document.getElementById('more-info');
    let clickFlag = false;

    button.addEventListener('click', function (event) {
        event.preventDefault();
        if (!clickFlag) {
            clickFlag = true;
            moreInfoTab.checked = true;

            setTimeout(() => {
                clickFlag = false;
            }, 300);
        }
       
        var elDistanceToTop = window.pageYOffset + moreInfoText.getBoundingClientRect().top
        var elHeader = document.querySelector('header');
        var totalScrollLength = elDistanceToTop - elHeader.offsetHeight - 250;

        window.scroll(0, totalScrollLength);
    });
}